import * as React from 'react';
import { FC } from 'react';

import { StyleSheet, ViewStyle } from 'react-native';

import { Box, BoxProps } from 'components/ui';
import { primitive } from 'styles/constants';

interface IProgressMeter extends BoxProps {
  percentage: number;
  _progress?: ViewStyle & { background?: string };
}

const ProgressMeterComponent: FC<React.PropsWithChildren<IProgressMeter>> = ({
  percentage,
  _progress,
  style,
  ...props
}) => {
  return (
    <Box {...props} style={[styles.wrapper, style]}>
      <Box
        style={[
          styles.progress,
          {
            backgroundColor: _progress?.background ?? primitive.$fieryRed,
            width: `${percentage}%`,
          },
        ]}
      />
    </Box>
  );
};

export const ProgressMeter = ProgressMeterComponent;

const styles = StyleSheet.create({
  wrapper: {
    backgroundColor: primitive.$greyFour,
    borderColor: primitive.$greyFour,
    borderRadius: 10,
    borderWidth: 1,
    height: 8,
    width: '100%',
  },
  progress: { borderRadius: 10, height: '100%' },
});
